import { memo } from "react";
import { formatDate } from "../../../libs/generalFunctions";
import { useSelector } from "react-redux";

import "./empInfoComp.scss";

function EmpInfoComp() {

const authMe = useSelector((state) => state.authme.data);    
console.log("authMe" ,authMe);
//====Event handler start here====
  //function to return the full emp name 
  const handleGetFullEmpName = (obj)=>{
    let fullName = "";
    if(obj.family_name){
      fullName = obj.name + ' ' + obj.family_name;
    }
     else{
       fullName = obj.name;
     }
    
     return fullName ;
   }  

//====Event handler end here====

  return (
    <div className='main_page'>
    <div className='main_page_header'>
        <span>معلومات الموظف</span>
    </div>
    <div className="main_page_content">

        <div className='main_page_right_side'>

        <div className='content_container_main_page'>
            <div className="left_main_page" >
            <span dir='rtl'>{authMe?.job_id}</span>
                </div>
            <div className="right_main_page" dir="rtl">
            <span >الرقم الوظيفي:</span>
            </div>
        </div>

        <div className='content_container_main_page'>
            <div className="left_main_page" >
            <span dir='rtl'>{authMe?.name} {authMe?.family_name}</span>
                </div>
            <div className="right_main_page" dir="rtl">
            <span >الاسم: </span>
            </div>
        </div>


        <div className='content_container_main_page'>
            <div className="left_main_page" >
            <span dir='rtl'>{authMe?.address}</span>
                </div>
            <div className="right_main_page" dir="rtl">
            <span >العنوان: </span>
            </div>
        </div>

        
        <div className='content_container_main_page'>
            <div className="left_main_page" >
            <span >{authMe?.mobile}</span>
                </div>
            <div className="right_main_page" dir="rtl">
            <span >رقم الموبايل: </span>
            </div>
        </div>



        <div className='content_container_main_page'>
            <div className="left_main_page" >
            <span dir="rtl">{authMe?.department?.title}</span>
                </div>
            <div className="right_main_page" dir="rtl">
            <span >القسم: </span>
            </div>
        </div>

          <div className='content_container_main_page'>
    <div className="left_main_page">
        <span dir='rtl'>{authMe?.factory?.title}</span>
    </div>
    <div className="right_main_page" dir="rtl">
        <span>المصنع:</span>
    </div>
</div>

    

        </div>

        <div className='main_page_left_side'>

        <div className='content_container_main_page'>
            <div className="left_main_page" >
            <span dir='rtl'>{authMe?.hiring_date && formatDate(authMe?.hiring_date)}</span>
                </div>
            <div className="right_main_page" dir="rtl">
            <span >تاريخ المباشرة: </span>
            </div>
        </div>

        <div className='content_container_main_page'>
            <div className="left_main_page" >
            <span dir='rtl'>{authMe?.qualification}</span>
                </div>
            <div className="right_main_page" dir="rtl">
            <span >المؤهلات: </span>
            </div>
        </div>

        <div className='content_container_main_page'>
            <div className="left_main_page" >
            <span dir='rtl'>{authMe?.job_position?.title}</span>
                </div>
            <div className="right_main_page" dir="rtl">
            <span >المنصب الوظيفي:</span>
            </div>
        </div>



        <div className='content_container_main_page last_main_page_element'>
            <div className="left_main_page" >
            <span  dir="rtl">{authMe?.department?.manager ? handleGetFullEmpName(authMe?.department?.manager) : ""}</span>
                </div>
            <div className="right_main_page" dir="rtl">
            <span >رئيس القسم: </span>
            </div>
        </div>

        <div className='content_container_main_page last_main_page_element'>
            <div className="left_main_page" >
            <span  dir="rtl">{authMe?.direct_manager ? handleGetFullEmpName(authMe?.direct_manager) : ""}</span>
                </div>
            <div className="right_main_page" dir="rtl">
            <span >المسؤول المباشر: </span>
            </div>
        </div>
    <div className='content_container_main_page'>
    <div className="left_main_page">
        <span dir='rtl'>{authMe?.work_schedule?.title}</span>
    </div>
    <div className="right_main_page" dir="rtl">
        <span>نظام الدوام:</span>
    </div>
</div>
      



        </div>


    </div>
</div>
  )
}

export default memo(EmpInfoComp);